export default __webpack_public_path__ + "static/media/hht1_ep19_minisitcom_02.613baee6.png";